import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

export default function TermsOfService() {
  return (
    <div className="pt-20 min-h-screen bg-[#F1FAEE]">
      {/* Header */}
      <section className="bg-[#14213D] py-16" data-testid="terms-hero">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-6"
            data-testid="back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <FileText className="w-8 h-8 text-[#00B4D8]" />
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white">
              Terms of Service
            </h1>
          </div>
          <p className="text-gray-400">Last updated: January 2024</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.article
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl p-8 md:p-12 shadow-sm"
          >
            <div className="prose max-w-none text-gray-700 space-y-6">
              <p>
                Welcome to Medical Access Inc. These Terms of Service ("Terms") govern your use 
                of our website accessmedicalgroup.online and our services. By accessing or using 
                our services, you agree to be bound by these Terms.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Acceptance of Terms
              </h2>
              <p>
                By using Medical Access Inc's website and services, you acknowledge that you have 
                read, understood, and agree to these Terms. If you do not agree, please do not 
                use our services.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Medical Disclaimer
              </h2>
              <p>
                The information provided on our website is for general informational purposes only 
                and does not constitute medical advice. Always consult with a qualified healthcare 
                provider for medical concerns. In case of a medical emergency, call 911 immediately.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Use of Services
              </h2>
              <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You will not:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide false or misleading information</li>
                <li>Use our services to harm others</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of our services</li>
                <li>Violate any applicable laws or regulations</li>
              </ul>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Appointments and Cancellations
              </h2>
              <p>
                When scheduling appointments through Medical Access Inc, you agree to provide 
                accurate information. We request at least 24 hours notice for cancellations. 
                Late cancellations or no-shows may be subject to fees.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Insurance and Billing
              </h2>
              <p>
                Patients are responsible for verifying insurance coverage before receiving services. 
                Medical Access Inc will make reasonable efforts to bill insurance providers, but 
                the patient is ultimately responsible for all charges.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Intellectual Property
              </h2>
              <p>
                All content on accessmedicalgroup.online, including text, graphics, logos, and 
                images, is the property of Medical Access Inc and is protected by copyright and 
                other intellectual property laws.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Limitation of Liability
              </h2>
              <p>
                Medical Access Inc shall not be liable for any indirect, incidental, special, 
                consequential, or punitive damages arising from your use of our services, to the 
                fullest extent permitted by law.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Changes to Terms
              </h2>
              <p>
                We reserve the right to modify these Terms at any time. Continued use of our 
                services after changes constitutes acceptance of the new Terms.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Governing Law
              </h2>
              <p>
                These Terms are governed by the laws of the State of Texas, United States, 
                without regard to conflict of law principles.
              </p>

              <h2 className="font-heading text-2xl font-semibold text-[#14213D] mt-8 mb-4">
                Contact Information
              </h2>
              <p>
                For questions about these Terms, please contact us:
              </p>
              <div className="bg-[#F1FAEE] rounded-lg p-6 mt-4">
                <p className="font-semibold text-[#14213D]">Medical Access Inc</p>
                <p>16475 N Dallas Pky, Suite 745</p>
                <p>Addison, TX 75001</p>
                <p className="mt-2">Phone: (866) 841-2149</p>
                <p>Email: <a href="mailto:legal@accessmedicalgroup.online" className="text-[#00B4D8] hover:underline">legal@accessmedicalgroup.online</a></p>
                <p>Website: <a href="https://accessmedicalgroup.online" className="text-[#00B4D8] hover:underline">accessmedicalgroup.online</a></p>
              </div>
            </div>
          </motion.article>
        </div>
      </section>
    </div>
  );
}
